import React from "react";
import desa_scooter from '../assets/images/desa_scooter.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://www.desascooters.nl/" target="_blank" rel="noreferrer"><img src={desa_scooter} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.desascooters.nl/" target="_blank" rel="noreferrer"><h2>Scooter Website for a Client</h2></a>
                <p>This website was developed using React, Typescript, Shadcn and Tailwind. It helped me gain knowledge about these tools.
                    Furthermore, I learned on how to implement a Google map using the Google Cloud Platform.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;